/**
 * API 请求封装
 *
 * 医学会环境下，将 increment 模块的 /das-manager 前缀改写为 /yxh-das-api；
 * /das-api 及其他路径保持不变。
 */

import {
  Get as _Get,
  Post as _Post,
  Put as _Put,
  Delete as _Delete
} from 'kjqk-commons/src/common/index.js'
import {
  isMedicalAssociationEnv,
  DAS_MANAGER_PREFIX,
  YXH_DAS_API_PREFIX,
  DAS_WEB_CENTER_PREFIX,
  YXH_DAS_WEB_CENTER_PREFIX,
  DAS_ASIS_PREFIX,
  YXH_DAS_ASIS_PREFIX
} from '../utils/envConfig'

/**
 * 医学会环境下，将 das-manager 前缀改写为 yxh-das-api
 * @param {string} url
 * @returns {string}
 */
export function resolveUrl(url) {
  if (!isMedicalAssociationEnv || !url) {
    return url
  }

  if (url.startsWith(DAS_MANAGER_PREFIX)) {
    return YXH_DAS_API_PREFIX + url.slice(DAS_MANAGER_PREFIX.length)
  } else if (url.startsWith(DAS_WEB_CENTER_PREFIX)) {
    return YXH_DAS_WEB_CENTER_PREFIX + url.slice(DAS_WEB_CENTER_PREFIX.length)
  } else if (url.startsWith(DAS_ASIS_PREFIX)) {
    return YXH_DAS_ASIS_PREFIX + url.slice(DAS_ASIS_PREFIX.length)
  }
  return url
}

export const Get = (url, config) => _Get(resolveUrl(url), config)
export const Post = (url, data, config) => _Post(resolveUrl(url), data, config)
export const Put = (url, data, config) => _Put(resolveUrl(url), data, config)
export const Delete = (url, config) => _Delete(resolveUrl(url), config)
